export const HANDOVER_CHECKBOOK_REQUEST = "HANDOVER_CHECKBOOK_REQUEST"
export const HANDOVER_CHECKBOOK_SUCCESS = "HANDOVER_CHECKBOOK_SUCCESS"
export const HANDOVER_CHECKBOOK_FAILURE = "HANDOVER_CHECKBOOK_FAILURE"
export const REMOVE_CHECKBOOK = "REMOVE_CHECKBOOK"
export const CLEAR_CHECKBOOKS = "CLEAR_CHECKBOOKS"
